import React from "react";
import lingua from "../../img/projects/Plumber/LinguaVerse.png";
import turbo from "../../img/projects/Plumber/TurboToyGarage.png";
import spice from "../../img/projects/Plumber/SpiceRoute.png";

const Projects = () => {
  return (
    <div className="my-12 w-full mx-auto" id="projects">
      <h2 className="text-center text-3xl my-8 underline decoration-solid uppercase">
        Projects
      </h2>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 justify-items-center">
        {/* 1st project */}
        <div className="card lg:w-80 bg-base-100 shadow-xl">
          <figure>
            <img className="hover:animate-shake" src={lingua} alt="" />
          </figure>
          <div className="card-body">
            <h2 className="card-title">LinguaVerse</h2>
            <p className="text-base">
              LinguaVerse is an online language learning platform that offers a
              diverse range of language courses. It aims to provide an immersive
              and interactive learning experience for individuals who want to
              explore and enhance their language skills.
            </p>

            <div class="card-actions justify-start">
              <a href="https://github.com/jesandante007/LinguaVerse-client">
                <div class="badge badge-outline button">Client</div>
              </a>
              <a href="https://github.com/jesandante007/LinguaVerse-server">
                <div class="badge badge-outline button">Server</div>
              </a>
              <a href="https://summer-camp-school-a061a.web.app/">
                <div class="badge badge-outline button">Live</div>
              </a>
            </div>
            <div className="card-actions  items-center justify-end">
              <label
                for="my-modal-1"
                class="btn modal-button btn-primary button"
              >
                Explore
              </label>

              <input type="checkbox" id="my-modal-1" class="modal-toggle" />
              <div class="modal   ">
                <div class="modal-box lg:w-11/12 lg:max-w-5xl  sm:modal-middle">
                  <label
                    for="my-modal-1"
                    class="btn btn-error btn-sm btn-circle absolute right-2 top-2"
                  >
                    ✕
                  </label>

                  <div className="flex items-center justify-between sm: flex-wrap my-4">
                    <div>
                      <h3 class="font-bold my-2 uppercase text-2xl">
                        LinguaVerse
                      </h3>
                    </div>
                    <div class="card-actions justify-start">
                      <a href="https://github.com/jesandante007/LinguaVerse-client">
                        <div class="badge badge-outline button">Client</div>
                      </a>
                      <a href="https://github.com/jesandante007/LinguaVerse-server">
                        <div class="badge badge-outline button">Server</div>
                      </a>
                      <a href="https://summer-camp-school-a061a.web.app/">
                        <div class="badge badge-outline button">Live</div>
                      </a>
                    </div>
                  </div>
                  <div class="card lg:card-side bg-base-100 flex-wrap ">
                    <div>
                      <h1 className="text-3xl my-4">Technology Used:</h1>
                      <div className="mt-3 font-bold">
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          Stripe Payment
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          Node
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          MongoDB
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          Express
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          cors
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          json webtoken
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          Middleware
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          env
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          Atlas
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          React
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          React router
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          React query
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          React hook form
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          Axios
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          React Toastify
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          Tailwind
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          DaisyUI
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          Vercel
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          firbase
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          firbase hooks
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          netlify
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          API
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          es6
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          JS
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          CSS
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          HTML
                        </div>
                      </div>
                    </div>
                    <div class="card-body">
                      <h2 class="card-title">Project Details</h2>
                      <p>
                        LinguaVerse is an innovative language learning platform
                        that connects passionate language learners with
                        experienced instructors. Discover a wide range of
                        language classes taught by native speakers and language
                        enthusiasts. Whether you're a beginner or advanced
                        learner, LinguaVerse offers interactive lessons,
                        engaging content, and a supportive community to help you
                        achieve your language learning goals. Immerse yourself
                        in a dynamic and culturally rich language learning
                        experience with LinguaVerse.
                      </p>
                      <h2 class="card-title">Features</h2>

                      <li>Browse and enroll in various language classes.</li>
                      <li>View popular classes and instructors.</li>
                      <li>
                        Register and create an account to manage your classes.
                      </li>
                      <li>Make payments securely for class enrollment.</li>
                      <li>Explore a wide range of languages and levels.</li>
                      <li>Instructors can add and update classes.</li>
                      <li>Admins can approve or reject classes.</li>
                      <li>
                        Admins can assign admin or instructor roles to users.
                      </li>
                    </div>
                  </div>
                  <div class="modal-action">
                    <label for="my-modal-1" class="btn btn-error">
                      close
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 2nd project */}
        <div className="card lg:w-80 bg-base-100 shadow-xl">
          <figure>
            <img className="hover:animate-shake" src={turbo} alt="" />
          </figure>
          <div className="card-body">
            <h2 className="card-title">TurboToyGarage</h2>
            <p className="text-base">
              TurboToyGarage is an online platform that offers a wide range of
              toy cars for enthusiasts. Whether you're passionate about sports
              cars, trucks, regular cars, or mini fire trucks and police cars,
              TurboToyGarage has something for everyone.
            </p>

            <div class="card-actions justify-start">
              <a href="https://github.com/jesandante007/toy-marketplace-client">
                <div class="badge badge-outline button">Client</div>
              </a>
              <a href="https://github.com/jesandante007/toy-marketplace-server">
                <div class="badge badge-outline button">Server</div>
              </a>
              <a href="https://toy-marketplace-259f8.web.app/">
                <div class="badge badge-outline button">Live</div>
              </a>
            </div>
            <div className="card-actions  items-center justify-end">
              <label
                for="my-modal-1"
                class="btn modal-button btn-primary button"
              >
                Explore
              </label>

              <input type="checkbox" id="my-modal-1" class="modal-toggle" />
              <div class="modal   ">
                <div class="modal-box lg:w-11/12 lg:max-w-5xl  sm:modal-middle">
                  <label
                    for="my-modal-1"
                    class="btn btn-error btn-sm btn-circle absolute right-2 top-2"
                  >
                    ✕
                  </label>

                  <div className="flex items-center justify-between sm: flex-wrap my-4">
                    <div>
                      <h3 class="font-bold my-2 uppercase text-2xl">
                        TurboToyGarage
                      </h3>
                    </div>
                    <div class="card-actions justify-start">
                      <a href="https://github.com/jesandante007/toy-marketplace-client">
                        <div class="badge badge-outline button">Client</div>
                      </a>
                      <a href="https://github.com/jesandante007/toy-marketplace-server">
                        <div class="badge badge-outline button">Server</div>
                      </a>
                      <a href="https://toy-marketplace-259f8.web.app/">
                        <div class="badge badge-outline button">Live</div>
                      </a>
                    </div>
                  </div>
                  <div class="card lg:card-side bg-base-100 flex-wrap ">
                    <div>
                      <h1 className="text-3xl my-4">Technology Used:</h1>
                      <div className="mt-3 font-bold">
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          Node
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          MongoDB
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          Express
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          cors
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          json webtoken
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          Middleware
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          env
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          Atlas
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          React
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          React router
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          React query
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          React hook form
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          Axios
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          React Toastify
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          tailwind
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          daisy UI
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          Vercel
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          firbase
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          firbase hooks
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          netlify
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          API
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          es6
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          JS
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          CSS
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          HTML
                        </div>
                      </div>
                    </div>
                    <div class="card-body">
                      <h2 class="card-title">Project Details</h2>
                      <p>
                        TurboToyGarage is a web application built using React,
                        Firebase, MongoDB, Tailwind CSS, DaisyUI, Express.js,
                        and React Router. It is an online platform that offers a
                        wide range of toy cars for enthusiasts. Whether you're
                        passionate about sports cars, trucks, regular cars, or
                        mini fire trucks and police cars, TurboToyGarage has
                        something for everyone.
                      </p>
                      <h2 class="card-title">Features</h2>

                      <li>
                        {" "}
                        <span className="font-semibold">
                          Extensive Collection:
                        </span>{" "}
                        Explore a diverse collection of toy cars, carefully
                        curated to cater to different interests and preferences.
                      </li>
                      <li>
                        {" "}
                        <span className="font-semibold">
                          User Authentication:
                        </span>{" "}
                        Create an account, sign in securely, and enjoy
                        personalized shopping experiences. JWT is used for
                        secure authentication and authorization.
                      </li>
                      <li>
                        {" "}
                        <span className="font-semibold">
                          Product Listings:
                        </span>{" "}
                        Browse through various categories of toy cars, including
                        sports cars, trucks, regular cars, mini fire trucks, and
                        mini police cars.
                      </li>
                      <li>
                        {" "}
                        <span className="font-semibold">
                          Product Details:
                        </span>{" "}
                        Get detailed information about each toy car, including
                        the seller, name, category, price, available quantity,
                        and features.
                      </li>
                      <li>
                        {" "}
                        <span className="font-semibold">
                          Search and Filtering:
                        </span>{" "}
                        Easily find your desired toy car using the search
                        functionality and filtering options
                      </li>
                      <li>
                        {" "}
                        <span className="font-semibold">
                          User Reviews and Ratings:
                        </span>{" "}
                        Read and provide reviews and ratings for the toy cars,
                        helping other users make informed decisions.
                      </li>
                      <li>
                        {" "}
                        <span className="font-semibold">
                          Responsive Design:
                        </span>{" "}
                        Experience seamless browsing across different devices
                        and screen sizes.
                      </li>
                    </div>
                  </div>
                  <div class="modal-action">
                    <label for="my-modal-1" class="btn btn-error">
                      close
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 3rd project */}
        <div className="card  lg:w-80 bg-base-100  shadow-xl ">
          <figure>
            <img className="hover:animate-shake" src={spice} alt="Shoes" />
          </figure>
          <div className="card-body">
            <h2 className="card-title">Spice Route</h2>
            <p>
              Spice Route is a React-based recipe website that features a wide
              range of dishes from various Indian chefs. Website allows users to
              search for their favorite Indian recipes, filter by chefs and save
              them for future reference.
            </p>

            <div class="card-actions justify-start">
              <a href="https://github.com/jesandante007/chef-recipe-hunter-client">
                <div class="badge badge-outline button">Client</div>
              </a>
              <a href="https://github.com/jesandante007/chef-recipe-hunter-server">
                <div class="badge badge-outline button">Server</div>
              </a>
              <a href="https://chef-recipe-hunter-fd2f4.web.app/">
                <div class="badge badge-outline button">Live</div>
              </a>
            </div>
            <div className="card-actions  items-center justify-end">
              <label
                for="my-modal-2"
                class="btn modal-button btn-primary button"
              >
                Explore
              </label>

              <input type="checkbox" id="my-modal-2" class="modal-toggle" />
              <div class="modal   ">
                <div class="modal-box lg:w-11/12 lg:max-w-5xl  sm:modal-middle">
                  <label
                    for="my-modal-2"
                    class="btn btn-error btn-sm btn-circle absolute right-2 top-2"
                  >
                    ✕
                  </label>

                  <div className="flex items-center justify-between sm: flex-wrap my-4">
                    <div>
                      <h3 class="font-bold my-2 uppercase text-2xl">
                        Spice Route
                      </h3>
                    </div>
                    <div class="card-actions justify-start">
                      <a href="https://github.com/jesandante007/chef-recipe-hunter-client">
                        <div class="badge badge-outline button">Client</div>
                      </a>
                      <a href="https://github.com/jesandante007/chef-recipe-hunter-server">
                        <div class="badge badge-outline button">Server</div>
                      </a>
                      <a href="https://chef-recipe-hunter-fd2f4.web.app/">
                        <div class="badge badge-outline button">Live</div>
                      </a>
                    </div>
                  </div>
                  <div class="card lg:card-side bg-base-100 flex-wrap ">
                    <div>
                      <h1 className="text-3xl my-4">Technology Used:</h1>
                      <div className="mt-3 font-bold">
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          Node
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          MongoDB
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          Express
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          cors
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          json webtoken
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          Middleware
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          env
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          Atlas
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          React
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          React router
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          React query
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          Tailwind
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          DaisyUI
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          React Toastify
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          Vercel
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          firbase
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          firbase hooks
                        </div>

                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          API
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          es6
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          JS
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          CSS
                        </div>
                        <div class="badge badge-md badge-primary my-2 uppercase mr-2">
                          HTML
                        </div>
                      </div>
                    </div>
                    <div class="card-body">
                      <h2 class="card-title">Project Details</h2>
                      <p>
                        Spice Route is a user-friendly website that allows users
                        to search for their favorite Indian recipes, filter by
                        chefs and save them for future reference. With its clean
                        and responsive design, Spice Route ensures that users
                        have a seamless experience while browsing through the
                        website.
                      </p>
                      <h2 class="card-title">Features</h2>
                      <li>SPA (Single Page Application)</li>
                      <li>Dynamically load data from server</li>
                      <li>Login, Registration, Authentication integrated</li>
                      <li>
                        View recipe details such as ingredients, cooking method,
                        and ratings
                      </li>
                      <li>
                        Save recipes to a personal collection for future
                        reference
                      </li>
                      <li>
                        Browse through a selection of chefs and their recipes
                      </li>
                      <li>
                        Access the website on different devices with its
                        responsive design
                      </li>
                    </div>
                  </div>
                  <div class="modal-action">
                    <label for="my-modal-2" class="btn btn-error">
                      close
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
